var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button pa-prev-button",class:_vm.additionalClass,attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[_vm._v("過去を取得")])}
var staticRenderFns = []

export { render, staticRenderFns }